import React, { Fragment } from "react";
import commonServices from "../../Utils/commonServices";

const _CustomerDetailShow = (props) => {
  // alert("name: " + props.customer?.name);
  return (
    <Fragment>
      {(props.customer === null || props.customer?.name === "undefined") && (
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bolder",
            marginTop: "50px",
          }}
        >
          No Customer Found
        </div>
      )}

      {props.customer !== null && props.customer?.name !== "undefined" && (
        <div style={{ marginLeft: "115px" }}>
          <div style={{ width: "50px", float: "left", marginTop: "40px" }}>
            <img
              style={{ width: "50px", height: "50px" }}
              className="mr-3 rounded-circle"
              src="./images/avatar/avatar.png"
            />
          </div>
          <div
            style={{
              width: "60%",
              float: "left",
              marginLeft: "30px",
              marginTop: "20px",
            }}
          >
            <div style={{ width: "500px", float: "left" }}>
              <h5 className="m-b-3">
                <b>Name: </b>
                {props.customer?.name}
              </h5>
            </div>
            <div style={{ width: "500px", float: "left" }}>
              <h5 className="m-b-3">
                <b>Cell No.: </b>
                {props.customer?.cellNo}
              </h5>
            </div>
            <div style={{ clear: "both" }}></div>

            <div style={{ width: "500px", float: "left" }}>
              <h5 className="m-b-3">
                <b>Register Date: </b>
                {commonServices.showDateRemovedT(
                  props.customer?.registeredDate
                )}
              </h5>
            </div>
            <div style={{ width: "500px", float: "left" }}>
              <h5 className="m-b-3">
                <b>Address: </b>
                {props.customer?.address}
              </h5>
            </div>
            <div style={{ width: "500px", float: "left" }}>
              <h5 className="m-b-3">
                <b>Email: </b>
                {props.customer?.email}
              </h5>
            </div>
            <div style={{ width: "500px" }}>
              <h5 className="m-b-3">
                <b>Alternet Phone No.: </b>
                {props.customer?.alternetPhone}
              </h5>
            </div>
          </div>
          <div className="clearBoth"></div>
        </div>
      )}
    </Fragment>
  );
};

export default _CustomerDetailShow;
